import Api from './Api';

interface GetCashFlowWidgetOptions {
  firstName: string;
  lastName: string;
  emailAddress: string;
  phoneNumber: string;
  fullAmount: string;
  amount: string;
  streetAddress: string;
  city: string;
  zip: string;
  state: string;
}

export default class CashFlowApi extends Api {
  public async getWidgetSession(options: GetCashFlowWidgetOptions) {
    const params = new URLSearchParams();

    params.set('firstName', options.firstName);
    params.set('lastName', options.lastName);
    params.set('emailAddress', options.emailAddress);
    params.set('phoneNumber', options.phoneNumber.replace(/\+1/g, ''));
    params.set('fullAmount', options.fullAmount);
    params.set('amount', options.amount);
    params.set('streetAddress', options.streetAddress);
    params.set('city', options.city);
    params.set('zip', options.zip);
    params.set('state', options.state);

    const widgetResponse = await this.fetch<{ sessionToken: string }>(`/cashFlow?${params}`, {
      checkAuthorization: true,
    });

    return widgetResponse;
  }
}
